import Features from "@app/feature-flags/features";
import { EntityTypeEnum, NetworkIntegrityAggregateGroup } from "@app/projects/enumerators";

// NPI Type is only meaningful on Provider Detail reached from an Excess Addresses bucket.
export const isNpiTypeEnabled = (enabledFeatureFlags: Set<string>, aggregateGroup?: string): boolean =>
  enabledFeatureFlags.has(Features.EXCESS_WARNINGS_COUNTING_UPDATES)
  && aggregateGroup === NetworkIntegrityAggregateGroup.ExcessAddresses;

// Historical runs carry NULL and render blank.
export const toNpiTypeLabel = (npiEntityType?: EntityTypeEnum | null): string => {
  if (npiEntityType === EntityTypeEnum.Individual) return "Type 1";
  if (npiEntityType === EntityTypeEnum.Facility) return "Type 2";
  return "";
};
